/**
 * theme-context.js
 */

import React from "react";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { Types } from 'utils/constants';
import themes from 'themes/themes';


export const ThemeContext = React.createContext();


export const ThemeProvider = ({ children }) => {
  const [state, setState] = React.useState({
    themeId: Types.Theme.LIGHT,
    theme: themes[Types.Theme.LIGHT]
  });


  const setTheme = React.useCallback((themeId) => {
    setState(p => ({
      ...p,
      themeId,
      theme: themes[themeId]
    }));
  }, []);


  // final state value
  const value = React.useMemo(() => ({
    ...state,
    setTheme,
  }), [
    state,
    setTheme
  ]);


  return (
    <>
      <ThemeContext.Provider value={value}>
        <MuiThemeProvider theme={state.theme}>
          <state.theme.GlobalStyles />
          {children}
        </MuiThemeProvider>
      </ThemeContext.Provider>
    </>
  );
};